export function oCampo(
   nombre,
   tipoDato,
   usarEnRespuesta,
   paramRecuperarEliminar,
   paramAgregar,
   paramActualizar,
   nombreRecuperar = ''
) {
   this.nombre = nombre;
   this.tipoDato = tipoDato;
   this.usarEnRespuesta = usarEnRespuesta;
   this.paramRecuperarEliminar = paramRecuperarEliminar;
   this.paramAgregar = paramAgregar;
   this.paramActualizar = paramActualizar;
   this.nombreRecuperar = nombreRecuperar;
}
